import 'owa-bootstrap'; // Important that owa-bootstrap come first, in order to bootstrap webpack settings
import 'owa-application'; // Import owa-application here to include globalStyles

// Initialize mail packages here:
import 'owa-mail-module-actions';

export { default as bootstrapDeepLinkModule } from './bootstrapDeepLink';
